/* eslint-disable */
import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Articles from "./articles";
import Charts from "./summery-charts";
import ArticleStore from "./Article-store";
import EqualizerIcon from "@mui/icons-material/Equalizer";
import FileCopyIcon from "@mui/icons-material/FileCopy";
import Footer from "./footer";
import logo from "./usjp-logo-1.png";
import { Grid, useMediaQuery, createTheme, Grow } from "@mui/material";

interface TabPanelProps {
  children?: React.ReactNode;
  dir?: string;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
}

export default function FullWidthTabs() {
  const theme = createTheme(); // You can customize the theme if needed
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isIpad = screen.width > 760 && screen.width < 900;

  const [value, setValue] = React.useState(0);
  async function loadArticles() {
    await ArticleStore.getInstance();
  }
  let series: any = [];
  const currentYear = new Date().getFullYear();

  async function getSeries() {
    series = await ArticleStore.getSeries();
  }

  React.useEffect(() => {
    loadArticles();
    if (series.length === 0) {
      getSeries();
    }
  });
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <>
      <title>
        Latest Research Carried out by Academic Staff ({currentYear - 5} -{" "}
        {currentYear})
      </title>
      <Box sx={{ bgcolor: "background.paper", width: "100%" }}>
        <AppBar
          position="static"
          sx={{
            backgroundColor: "#800000",
            background: "linear-gradient(to bottom, #800000 , #710209 )",
          }}
        >
          <Grid container>
            <Grid
              item
              xs={12}
              md={1}
              sx={{
                textAlign: isMobile || isIpad ? "center" : "initial",
              }}
            >
              <img
                src={logo}
                alt="Logo"
                width={isMobile || isIpad ? 110 : 80}
                height={isMobile || isIpad ? 110 : 80}
                style={{
                  marginTop: 10,
                  marginLeft: isMobile || isIpad ? "auto" : 1,
                }}
              />
            </Grid>

            <Grid
              item
              xs={12}
              md={9}
              sx={{
                textAlign: isMobile || isIpad ? "center" : "initial",
              }}
            >
              <Grid container>
                <Grid item xs={12} md={3.3}>
                  <Typography
                    variant="h6"
                    sx={{
                      marginTop: isMobile || isIpad ? 1 : 2,
                      fontSize: isMobile || isIpad ? "13px" : "15px",
                      marginLeft: isMobile || isIpad ? "auto" : -1,
                      color: "yellow",
                    }}
                  >
                    <Typography
                      sx={{
                        color: "white",
                        marginBottom: -3,
                      }}
                    >
                      Department of Information Technology
                    </Typography>
                    <br />
                    Faculty of Management Studies and Commerce
                    <br />
                    University of Sri Jayewardenepura - Sri Lanka
                  </Typography>
                </Grid>

                <Grid
                  item
                  xs={12}
                  md={7.2}
                  sx={{ display: "flex", alignItems: "center" }}
                >
                  {!isMobile && !isIpad && (
                    <Box
                      sx={{
                        width: 0.002,
                        bgcolor: "grey.500",
                        height: "70px",
                        marginX: "auto",
                        marginTop: 2,
                      }}
                    />
                  )}

                  {!isMobile && (

                    <Grow
                      in={true}
                      style={{
                        transformOrigin: isMobile || isIpad ? "-1 0 0" : "0 0 0",
                      }}
                      {...(true ? { timeout: 1000 } : {})}
                    >
                      <Typography
                        variant="h6"
                        sx={{
                          marginTop: 2,
                          fontSize: isMobile ? "24px" : "30px",
                          marginLeft: isMobile ? 0 : isIpad ? 12 : 3,
                          color: "#FFF",
                        }}
                      >
                        Welcome to Research Portal - DIT

                        <Grow
                          in={true}
                          style={{
                            transformOrigin:
                              isMobile || isIpad ? "-1 0 0" : "0 0 0",
                          }}
                          {...(true ? { timeout: 2000 } : {})}
                        >
                          <Typography
                            variant="h6"
                            sx={{
                              marginTop: 0,
                              fontSize: isMobile ? "20px" : "22px",
                              color: "#DDDDDD",
                            }}
                          >
                            Latest Research Carried out by Academic Staff (
                            {currentYear - 5} - {currentYear})
                          </Typography>
                        </Grow>

                      </Typography>
                    </Grow>

                  )}

                </Grid>


                {isMobile && (

                  <Grid
                    item
                    xs={12}
                    sx={{ display: "flex", alignItems: "center" }}
                  >
                    <Grow
                      in={true}
                      style={{
                        transformOrigin: isMobile || isIpad ? "-1 0 0" : "0 0 0",
                      }}
                      {...(true ? { timeout: 1000 } : {})}
                    >
                      <Typography
                        variant="h6"
                        sx={{
                          marginTop: 2,
                          fontSize: isMobile ? "24px" : "30px",
                          marginLeft: isMobile ? 0 : isIpad ? 12 : 3,
                          color: "#FFF",
                        }}
                      >
                        Welcome to Research Portal - DIT

                        <Grow
                          in={true}
                          style={{
                            transformOrigin:
                              isMobile || isIpad ? "-1 0 0" : "0 0 0",
                          }}
                          {...(true ? { timeout: 2000 } : {})}
                        >
                          <Typography
                            variant="h6"
                            sx={{
                              marginTop: 0,
                              fontSize: isMobile ? "20px" : "22px",
                              color: "#C6C6C6",
                            }}
                          >
                            Latest Research Carried out by Academic Staff (
                            {currentYear - 5} - {currentYear})
                          </Typography>
                        </Grow>

                      </Typography>
                    </Grow>
                  </Grid>)}


              </Grid>
            </Grid>

            <Grid item xs={12} md={12} sx={{ marginTop: 1, marginBottom: 1 }}>
              <Tabs
                value={value}
                onChange={handleChange}
                indicatorColor="secondary"
                textColor="inherit"
                variant="fullWidth"
                aria-label="full width tabs example"
              >
                <Tab
                  icon={<FileCopyIcon />}
                  iconPosition="start"
                  label="Research Articles"
                  {...a11yProps(0)}
                />
                <Tab
                  icon={<EqualizerIcon />}
                  iconPosition="start"
                  label="Summary Charts"
                  {...a11yProps(1)}
                />
              </Tabs>
            </Grid>
          </Grid>
        </AppBar>
        <Box borderBottom={1} sx={{ borderColor: "grey.500" }} />
        <TabPanel value={value} index={0} dir={theme.direction}>
          <Articles></Articles>
        </TabPanel>
        <TabPanel value={value} index={1} dir={theme.direction}>
          <Charts></Charts>
        </TabPanel>
      </Box>

      <Footer></Footer>
    </>
  );
}
